import { useState } from 'react'
import { Recordatorios } from '../../../../recordatorios/Recordatorios'
import { AppConstantes } from '../../../../../utils/Constantes'

export const RecordatoriosRecurrentes = ({
  tabActivo,
  control,
  errors,
  getValues,
  isModoEditar,
  register,
  tipo,
  trigger,
  watch,
  isRemoverRecordatorios = false,
}: Props) => {
  // Recordatorios "recurrentes" en condicionante:
  // Solo aplica al crear (no en editar) y se guarda como lote junto con la condicionante.
  const [totalRecordatorios, setTotalRecordatorios] = useState(0)

  return (
    <div
      id='tab_recordatorios'
      role='tabpanel'
      className={`tab-pane fade ${
        tabActivo === AppConstantes.CVE_TAB_RECORDATORIOS_RECURRENTES ? 'show active' : null
      }`}>
      <div className='w-50 mx-auto'>
        <div className='my-5'>
          <h4 className='d-inline'>Recordatorios </h4>
          <span className='text-muted fs-4'>| {totalRecordatorios} total</span>
        </div>
        <Recordatorios
          {...{
            control,
            errors,
            getValues,
            isModoEditar,
            register,
            tipo,
            watch,
            trigger,
            setTotalRecordatorios,
          }}
          esRecurrente
          esAtributoAnidado={false}
          nombreUseFieldArray='recordatoriosRecurrentes'
          isRemoverRecordatorios={isRemoverRecordatorios}
        />
      </div>
    </div>
  )
}

type Props = {
  tabActivo: string
  isModoEditar: boolean
  getValues: any
  tipo: string //PERTENECE A UNA TAREA O A UNA AUTORIZACION: 'TAREA', 'AUTORIZACION'
  control: any
  register: any
  watch?: any
  trigger?: any
  errors: any
  isRemoverRecordatorios?: boolean
}
